import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  getDefaults as getActivityDefaults,
} from 'models/Activity';
import Group, { GroupOptions } from 'models/Group';
import { ReviewStatus } from 'models/Review';

export interface AltcsApplicationStatusUpdateOptions extends ActivityOptions {
  type: ActivityType.ALTCS_APPLICATION_STATUS_UPDATE;
  data: Partial<BaseActivityDataOptions & { status: ReviewStatus; provider: Partial<GroupOptions> | null }>;
}

export function getDefaults(): AltcsApplicationStatusUpdateOptions {
  const activityDefaults = getActivityDefaults();

  return {
    ...activityDefaults,
    type: ActivityType.ALTCS_APPLICATION_STATUS_UPDATE,
    data: {
      ...activityDefaults.data,
      status: ReviewStatus.PENDING,
      provider: null,
    },
  };
}

export default class AltcsApplicationStatusUpdate extends Activity {
  declare type: ActivityType.ALTCS_APPLICATION_STATUS_UPDATE;
  declare data: BaseActivityData & {
    status: ReviewStatus;
    provider: Group | null;
  };

  constructor(options: Partial<AltcsApplicationStatusUpdateOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);

    this.data = {
      ...this.data,
      provider: opts.data.provider ? new Group(opts.data.provider) : null,
    };
  }

  get typeLabel() {
    return 'ALTCS Status Update';
  }
}
